export default __webpack_public_path__ + "assets/front/scss/error.20ce7bc37a740b47eba6e9e589265bc5.css";